import request from "@/utils/request";

/**
 * 获取当前用户信息
 */
export function getMyUserInfo() {
  return request({
    url: "/app/appUser/myUserInfo",
    method: "get",
  });
}

/**
 * 修改用户信息
 * @param {Object} data
 * @param {number} data.userId - 用户ID
 * @param {string} data.headPortrait - 头像
 * @param {string} data.enterpriseName - 企业名称
 * @param {string} data.relationName - 联系人
 * @param {string} data.relationPhone - 联系电话
 * @param {string} data.postName - 职务名称
 * @param {string} data.role - 角色(supplier|purchase)
 * @param {string} data.wxNumber - 微信号
 * @param {string} data.mail - 邮箱
 * @param {string} data.address - 地址
 * @param {string} data.businessLicense - 营业执照
 */
export function editUser(data) {
  return request({
    url: "/app/appUser/edit",
    method: "post",
    data,
  });
}

/**
 * 获取用户详细信息
 */
export function getAppUser(id) {
  return request({
    url: `/app/appUser/${id}`,
    method: "get",
  });
}
